export const enabled = value => value === true || value === 1 || value === '1'

export function categoryIds(value) {
  const values = Array.isArray(value) ? value : String(value || '').split(',')

  if (values.length === 1 && String(values[0]).trim() === '') return []

  return [...new Set(values.map(v => Number(typeof v === 'object' && v ? v.id : v)).map(v => (Number.isSafeInteger(v) && v > 0 ? v : 0)))]
}

export function categoryPolicy(categories) {
  const byId = new Map()
  const flatten = rows => (rows || []).forEach(row => { byId.set(Number(row.id), row); flatten(row.children) })
  flatten(categories)
  const cache = new Map()
  function isPublic(categoryId, visiting = new Set()) {
    const id = Number(categoryId)
    if (cache.has(id)) return cache.get(id)
    const category = byId.get(id)
    if (!category || visiting.has(id) || !enabled(category.public)) return false
    visiting.add(id)
    const result = !Number(category.parent_id) || isPublic(category.parent_id, visiting)
    visiting.delete(id)
    cache.set(id, result)

    return result
  }

  return { byId, isPublic }
}

export function visibility(record, profilePublic, policy) {
  if (!enabled(profilePublic)) return { effective_public: false, privacy_reason: 'profile' }
  if (!enabled(record.public)) return { effective_public: false, privacy_reason: 'record' }
  const ids = categoryIds(record.categories)
  if (!ids.length) return { effective_public: false, privacy_reason: 'uncategorized' }
  if (!ids.every(id => policy.isPublic(id))) return { effective_public: false, privacy_reason: 'category' }

  return { effective_public: true, privacy_reason: 'public' }
}

export const privacyExplanations = {
  public: 'Visible on your public profile.',
  profile: 'Hidden from the public because your profile is private.',
  record: 'Hidden from the public because this record is private.',
  category: 'Hidden from the public because a category or parent category is private or unavailable.',
  uncategorized: 'Hidden from the public until a public category is selected.',
  diary: 'Diary entries are private. Adding an entry to your biography creates a separate record with its own privacy settings.',
  unknown: 'Public visibility has not been verified. Reload to check the latest privacy settings.',
}
